import React from 'react'
import './banner.css'

export default function banner() {
  return (
  <div className='banner'>
    <div className='banner-left'>
        <h2 className='top-text'>Little Lemmon</h2>
        <h4 className='sub-text'>Chicago</h4>
          <p className='main-text'>
               Lorem ipsum dolor sit amet, consectetur adipiscing elit, 
               sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
               Mi in nulla posuere sollicitudin a
          </p>
          <div className='btn'>Reserve a Table</div>
    </div>
    <div className='banner-right'>
          <img src="/images/BannerImg.jpg" alt="Banner" className='bannerImg' />
    </div>
       
  </div>
    
  )
}
